<template>
  <div>
    <div v-if="loading" class="text-center py-4">
      <b-spinner small /> กำลังโหลด...
    </div>

    <div v-else>
      <!-- Tab เลือกคลัง (WarehouseType) -->
      <b-tabs v-if="warehouseTypes.length > 1" v-model="activeWhIndex" class="mb-1">
        <b-tab
          v-for="wh in warehouseTypes"
          :key="wh"
          :title="warehouseLabel(wh)"
        />
      </b-tabs>

      <!-- แต่ละประเภทลูกค้า -->
      <b-card
        v-for="ct in customerTypes"
        :key="ct.id"
        no-body
        class="mb-1 border"
      >
        <b-card-header class="py-1 bg-light">
          <strong>{{ ct.label }}</strong>
        </b-card-header>
        <b-card-body class="p-1">
          <b-row>
            <b-col
              v-for="tr in transports"
              :key="tr.id"
              cols="12"
              md="6"
              class="mb-1"
            >
              <div class="font-weight-bold mb-50 text-primary">{{ tr.label }}</div>
              <table class="table table-sm table-bordered mb-0 rate-table">
                <thead>
                  <tr class="text-center">
                    <th style="width:34%">ประเภทสินค้า</th>
                    <th style="width:33%">กิโลละ (บาท)</th>
                    <th style="width:33%">คิวละ (บาท)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="pt in productTypes" :key="pt.id">
                    <td>{{ pt.label }}</td>
                    <td>
                      <b-form-input
                        size="sm"
                        type="number"
                        step="0.01"
                        v-model="cell(activeWh, ct.id, tr.id, pt.id).weightRate"
                        :placeholder="defaultPlaceholder(activeWh, ct.id, tr.id, pt.id, 'weightRate')"
                        @keypress="isNumberWithDot"
                      />
                    </td>
                    <td>
                      <b-form-input
                        size="sm"
                        type="number"
                        step="0.01"
                        v-model="cell(activeWh, ct.id, tr.id, pt.id).cubicRate"
                        :placeholder="defaultPlaceholder(activeWh, ct.id, tr.id, pt.id, 'cubicRate')"
                        @keypress="isNumberWithDot"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>

      <div class="d-flex justify-content-end mt-1">
        <b-button variant="primary" :disabled="saving" @click="save">
          <b-spinner v-if="saving" small /> บันทึก
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import {
  BTabs, BTab, BCard, BCardHeader, BCardBody, BRow, BCol,
  BFormInput, BButton, BSpinner,
} from 'bootstrap-vue'
import { header_token } from '@/views/token.js'
import { taobaoService_dotnet } from '@/views/global.js'
import { isNumberWithDot } from '@/views/global_function.js'

export default {
  components: {
    BTabs, BTab, BCard, BCardHeader, BCardBody, BRow, BCol,
    BFormInput, BButton, BSpinner,
  },
  props: {
    customerId: { type: Number, default: 0 },
  },
  data() {
    return {
      loading: false,
      saving: false,
      warehouseTypes: [0],
      activeWhIndex: 0,
      // cells[key] = { id, weightRate, cubicRate, description }
      cells: {},
      defaults: {}, // key -> { weightRate, cubicRate }
      customerTypes: [
        { id: 1, label: 'นำเข้าอย่างเดียว' },
        { id: 2, label: 'ฝากสั่ง+นำเข้า' },
        { id: 3, label: 'เอกสารนำเข้า' },
      ],
      transports: [
        { id: 1, label: 'รถ' },
        { id: 2, label: 'เรือ' },
      ],
      productTypes: [
        { id: 1, label: 'ทั่วไป' },
        { id: 2, label: 'อย.' },
        { id: 3, label: 'มอก.' },
        { id: 4, label: 'พิเศษ' },
      ],
      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    activeWh() {
      return this.warehouseTypes[this.activeWhIndex] || 0
    },
  },
  watch: {
    customerId() {
      this.load()
    },
  },
  created() {
    this.load()
  },
  methods: {
    isNumberWithDot,

    key(wh, ct, tr, pt) {
      return `${wh}-${ct}-${tr}-${pt}`
    },

    warehouseLabel(wh) {
      if (wh === 0) return 'คลังมาตรฐาน'
      if (wh === 4) return 'คลังพิเศษ'
      return `คลัง ${wh}`
    },

    // คืน cell object (สร้างใหม่ถ้ายังไม่มี) — ให้ reactive ด้วย $set
    cell(wh, ct, tr, pt) {
      const k = this.key(wh, ct, tr, pt)
      if (!this.cells[k]) {
        this.$set(this.cells, k, { id: 0, weightRate: '', cubicRate: '', description: '' })
      }
      return this.cells[k]
    },

    defaultPlaceholder(wh, ct, tr, pt, field) {
      if (this.customerId === 0) return ''
      const d = this.defaults[this.key(wh, ct, tr, pt)]
      if (!d) return ''
      const v = d[field]
      return (v === null || v === undefined) ? '' : `มาตรฐาน: ${v}`
    },

    async load() {
      this.loading = true
      try {
        const res = await axios.post(
          taobaoService_dotnet + 'app/AdminShippingRate/list',
          { loginToken: '', customerID: this.customerId },
          { headers: header_token },
        )
        const data = res.data || {}

        // ซ่อนคลังพิเศษ (WarehouseType = 4) ออกก่อน
        const whList = (data.warehouseTypes || []).filter(wh => wh !== 4)
        this.warehouseTypes = whList.length ? whList : [0]
        this.activeWhIndex = 0

        // เก็บค่า default ไว้โชว์เป็น placeholder
        this.defaults = {}
        ;(data.defaultRates || []).forEach(r => {
          this.defaults[this.key(r.warehouseType || 0, r.customerType, r.transportTypeID, r.productType)] = {
            weightRate: r.weightRate,
            cubicRate: r.cubicRate,
          }
        })

        // เติมค่าเรทของลูกค้าลง cells
        this.cells = {}
        ;(data.rates || []).forEach(r => {
          const k = this.key(r.warehouseType || 0, r.customerType, r.transportTypeID, r.productType)
          this.$set(this.cells, k, {
            id: r.id,
            weightRate: r.weightRate,
            cubicRate: r.cubicRate,
            description: r.description || '',
          })
        })
      } catch (e) {
        this.$bvToast.toast('โหลดข้อมูลเรทไม่สำเร็จ', { title: 'ผิดพลาด', variant: 'danger', solid: true })
      } finally {
        this.loading = false
      }
    },

    buildPayload() {
      const rows = []
      this.warehouseTypes.forEach(wh => {
        this.customerTypes.forEach(ct => {
          this.transports.forEach(tr => {
            this.productTypes.forEach(pt => {
              const c = this.cells[this.key(wh, ct.id, tr.id, pt.id)]
              if (!c) return
              const hasWeight = c.weightRate !== '' && c.weightRate !== null
              const hasCubic = c.cubicRate !== '' && c.cubicRate !== null
              // ส่งเฉพาะช่องที่มีค่า หรือแถวเดิมที่เคยมี id (เพื่ออัปเดต/ล้างได้)
              if (!c.id && !hasWeight && !hasCubic) return
              rows.push({
                id: c.id || 0,
                warehouseType: wh === 0 ? null : wh,
                transportTypeID: tr.id,
                customerType: ct.id,
                productType: pt.id,
                weightRate: Number(c.weightRate) || 0,
                cubicRate: Number(c.cubicRate) || 0,
                description: c.description || '',
              })
            })
          })
        })
      })
      return rows
    },

    async save() {
      this.saving = true
      try {
        const res = await axios.post(
          taobaoService_dotnet + 'app/AdminShippingRate/save',
          {
            loginToken: '',
            customerID: this.customerId,
            staffBranchID: this.userData && this.userData.data ? this.userData.data.customerID : 0,
            rates: this.buildPayload(),
          },
          { headers: header_token },
        )
        if (res.data && res.data.status === 'success') {
          this.$bvToast.toast('บันทึกเรทเรียบร้อย', { title: 'สำเร็จ', variant: 'success', solid: true })
          await this.load()
          this.$emit('saved')
        } else {
          this.$bvToast.toast(res.data.message || 'บันทึกไม่สำเร็จ', { title: 'ผิดพลาด', variant: 'danger', solid: true })
        }
      } catch (e) {
        this.$bvToast.toast('บันทึกไม่สำเร็จ', { title: 'ผิดพลาด', variant: 'danger', solid: true })
      } finally {
        this.saving = false
      }
    },
  },
}
</script>

<style scoped>
.rate-table th {
  font-size: 0.8rem;
  vertical-align: middle;
}
.rate-table td {
  vertical-align: middle;
}
</style>
